import React from 'react';
import { calculateTabWidth } from 'views/Analytics/AnalyticsScrollMenu/ScrollMenuUtils';
import BzmIcon from '../../../components/icons/BzmIcon';

interface ScrollMenuItemProps {
  id: string | number;
  title: any;
  icon: any;
  selected: boolean;
  closeHandler: (event: any, id: any) => void;
  selectHandler: (id: any) => void;
}

export const ScrollMenuItem = ({ id, title, icon, selected, closeHandler, selectHandler }: ScrollMenuItemProps) => {
  const selectTabHandler = (event: any) => {
    if (event.keyCode === 13) {
      selectHandler(id);
    }
  };

  return (
    <div
      onKeyDown={(event: any) => selectTabHandler(event)}
      tabIndex={0}
      role="button"
      className={`menu-item ${selected ? 'active' : ''}`}
      style={{ width: calculateTabWidth(title) + 'px' }}
    >
      <span className="mr-2" style={{ position: 'relative', top: '3px' }}>
        {icon}
      </span>
      {title}
      <BzmIcon
        onClick={(event: any) => closeHandler(event, id)}
        variant={'icon-bzm-close-remove'}
        className={'ml-1 icon-theme-gray-60'}
        style={{ position: 'relative', left: '5px' }}
      ></BzmIcon>
    </div>
  );
};
